import { RequestSettingsBase } from '@app/entities/request-settings';
import { PlatformTypes } from '@app/modules/core/constants/platform-types';
import { SalesType } from '@app/modules/core/constants/sales-type';
import { isActiveMobileInterface } from '@app/modules/core/mappers/mobile-interface.mapper';
import { environment as ENV } from '@environment';
import { languageFormat } from '@ux/mappers/language.mapper';

export function getBaseRequestSettings(
  isMobile: boolean, saleType: SalesType = SalesType.Regular
): RequestSettingsBase {
  return {
    SaleType: saleType,
    Language: languageFormat(ENV.countryInfo.locale),
    BusinessUnitCode: ENV.business_unit_code,
    BranchCode: ENV.branchcode,
    Platform: getPlatform(isMobile)
  };
}

export function getPlatform(isMobile: boolean): PlatformTypes {
  if (!isMobile) return PlatformTypes.DESKTOP;
  else if (isActiveMobileInterface()) return PlatformTypes.MOBILE_APP;
  else return PlatformTypes.MOBILE_WEB;
}
